export default __webpack_public_path__ + "static/media/s_wdt_c_4.e2a39203.mp3";